import config from '../../../constants/config';

// Taboola Tracking Pixel
if (config.TABOOLA_TRACKING_PIXEL) {
  /* eslint-disable */
  window._tfa = window._tfa || [];
  window._tfa.push({
    notify: 'event',
    name: 'page_view',
    id: config.TABOOLA_TRACKING_PIXEL,
  });
  !(function (t, f, a, x) {
    if (!document.getElementById(x)) {
      t.async = 1;
      t.src = a;
      t.id = x;
      f.parentNode.insertBefore(t, f);
    }
  })(
    document.createElement('script'),
    document.getElementsByTagName('script')[0],
    `//cdn.taboola.com/libtrc/unip/${config.TABOOLA_TRACKING_PIXEL}/tfa.js`,
    'tb_tfa_script'
  );
  /* eslint-enable */
}



// WEBPACK FOOTER //
// ./src/assets/helpers/scripts/taboola.js